// Components
import NoRowsOverlay from "@/Layouts/components/Tables/DataSmartTable/additional/NoRowsOverlay";
import CommonToolbar from "@/Layouts/components/Tables/DataSmartTable/toolbar/CommonToolbar";
import DataSmartTable from "@/Layouts/components/Tables/DataSmartTable";
// Helpers
import { getGroupColumnDefinition } from "./groupcoldef";
// Types
import { DataGridPremiumProps, GridColDef, useGridApiRef } from "@mui/x-data-grid-premium";
import { ProductsCombinedTableProps } from "@/Washouts/types/finance";

export function ProductsCombinedTable(props: Readonly<ProductsCombinedTableProps>) {
	const title = props.title ?? "Product Conversions";
	const { columns = [], rows = [] } = props;
	const apiRef = useGridApiRef();

	const getTreeDataPath: DataGridPremiumProps["getTreeDataPath"] = (row) => row.hierarchy;

	return (
		<DataSmartTable
			{...props.tableProps}
			apiRef={apiRef}
			columns={columns as GridColDef[]}
			rows={rows}
			treeData
			disableColumnMenu
			disableRowSelectionOnClick
			disableMultipleRowSelection
			checkboxSelection={false}
			getTreeDataPath={getTreeDataPath}
			groupingColDef={getGroupColumnDefinition(true, apiRef)}
			defaultGroupingExpansionDepth={1}
			columnVisibilityModel={{
				_id: false,
			}}
			initialState={{
				aggregation: {
					model: { penetration: "sum" },
				},
			}}
			slots={{
				toolbar: CommonToolbar,
				noRowsOverlay: NoRowsOverlay,
			}}
			slotProps={{
				toolbar: {
					customTitle: {
						hide: false,
						label: title,
						sx: { mb: "15px" },
					},
				},
				noRowsOverlay: {
					title: `No ${title} Data`,
				},
			}}
			customProps={{}}
		/>
	);
}
